export const targetingSites = {
  drive: 'Drive',
  rac: 'RAC Cars',
};
